import React from "react";

// value widgets
import DateWidget from "./value/Date";
import DateTimeWidget from "./value/DateTime";
import TimeWidget from "./value/Time";
import SelectWidget from "./value/Select";
import TextWidget from "./value/Text";
import TextAreaWidget from "./value/TextArea";
import NumberWidget from "./value/Number";
import PriceWidget from "./value/Price";
import SliderWidget from "./value/Slider";
import RangeWidget from "./value/Range";
import BooleanWidget from "./value/Boolean";
import MultiSelectWidget from "./value/MultiSelect";
import AutocompleteWidget from "./value/Autocomplete";
import TreeSelectWidget from "./value/TreeSelect";

// field select widgets
import FieldSelect from "./core/FieldSelect";
import FieldDropdown from "./core/FieldDropdown";
import FieldCascader from "./core/FieldCascader";
import FieldTreeSelect from "./core/FieldTreeSelect";

// core components
import Icon from "./core/Icon";
import Button from "./core/Button";
import ButtonGroup from "./core/ButtonGroup";
import Conjs from "./core/Conjs";
import Switch from "./core/Switch";
import ValueSources from "./core/ValueSources";
import { useConfirm, Confirm } from "./core/Confirm";

// Provider
import { Provider } from "./core/Provider";
var AntdWidgets = {
  DateWidget: DateWidget,
  DateTimeWidget: DateTimeWidget,
  TimeWidget: TimeWidget,
  SelectWidget: SelectWidget,
  TextWidget: TextWidget,
  TextAreaWidget: TextAreaWidget,
  NumberWidget: NumberWidget,
  PriceWidget: PriceWidget,
  SliderWidget: SliderWidget,
  RangeWidget: RangeWidget,
  BooleanWidget: BooleanWidget,
  MultiSelectWidget: MultiSelectWidget,
  AutocompleteWidget: AutocompleteWidget,
  TreeSelectWidget: TreeSelectWidget,
  FieldSelect: FieldSelect,
  FieldDropdown: FieldDropdown,
  FieldCascader: FieldCascader,
  FieldTreeSelect: FieldTreeSelect,
  Icon: Icon,
  Button: Button,
  ButtonGroup: ButtonGroup,
  Conjs: Conjs,
  Switch: Switch,
  ValueSources: ValueSources,
  useConfirm: useConfirm,
  Confirm: Confirm,
  Provider: Provider
};
export default AntdWidgets;